export const promptIntro = (userLanguageName: string, practiceLanguageName: string) => {
  const numberOfSteps = 5;

  return `
  I am learning ${practiceLanguageName} and have never tried it before. 
  My native language is ${userLanguageName}. 
  Please make a ${numberOfSteps} step guide/wizard `;
};

export const promptEnd = (userLanguageName: string, practiceLanguageName: string) => `
  Explanations about ${practiceLanguageName} should be in comparison with ${userLanguageName}.
  Extract 0-3 short examples from the step, that I can read aloud. Save them to the examples list. 
  Example "text" should be in ${practiceLanguageName}. Translate the example text to ${userLanguageName} and save under "translation".
  Do not direct on where to find information. 
  Do not tell me where and how to practice. 
  After each step, write a multiple choice question with four answer options to quiz me on the topic I just learned. 
  The answer to the question must be explained directly in the original step.
  Write the guide in ${userLanguageName}.`;
